<script lang="ts">
  import type { ButterflyAPI, ButterflyPost, ButterflyRelation } from '$lib/types';
  import getRelation from '$lib/getRelation';

  export let post: ButterflyAPI<ButterflyPost>;

  const tags = post.data.relationships.terms.data
    .filter((t: ButterflyRelation) => t.type === 'term<tags>')
    .map((t: ButterflyRelation) => getRelation(t, post.included));
</script>

{#if tags.length}
  <ul class="tags d-flex g2 fw-wrap">
    {#each tags as tag}
      <li class="tag"><a href="/tags/{tag.id}">{tag.attributes.name}</a></li>
    {/each}
  </ul>
{/if}
